export default {
  title: "Deal Info",
  deal_name: "Name",
  added_on: "Added on",
};
